import { render, staticRenderFns } from "./ApiTokens.vue?vue&type=template&id=1960542a&scoped=true&"
import script from "./ApiTokens.vue?vue&type=script&lang=js&"
export * from "./ApiTokens.vue?vue&type=script&lang=js&"
import style0 from "./ApiTokens.vue?vue&type=style&index=0&id=1960542a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1960542a",
  null
  
)

export default component.exports